export default __webpack_public_path__ + "static/media/GuidelinesFR.1eb4b558.pdf";